<div class="version-history-files-container">
  <ng-container *ngIf="(attachedFiles?.length ?? 0) > 0; else noUpload">
    <ng-container *ngFor="let group of mappedAttachedFiles | keyvalue: originalOrder">
      <ng-container *ngIf="group.key !== undefined">
        <span class="title">{{'proposalDetails.' + mapUploadLocation(group.key) | translate}}</span>
        <div class="download-wrapper w-100">
          <ng-container *ngFor="let file of group.value; trackBy: trackByFileId">
            <div class="d-flex flex-row upload-container">
              <div class="d-flex align-items-center justify-content-center">
                <span class="upload-icon-background">
                  <img class="upload-icon"
                       [src]="fileUploadService.getIconSourceForFilename(file.name)"
                       alt="">
                </span>
              </div>

              <div class="upload-file-text">
                <span>{{file.name}}</span><br>
                <div class="d-flex justify-content-start upload-file-subtext">
                  {{file.sizeInBytes | formatFileSize}}
                </div>
              </div>

              <ng-container *ngIf="isAvailable(file); else deletedBadge">
                <button *ngIf="!loadingStatus.get(file.id)"
                        class="download-button"
                        (click)="downloadFile(file)">
                  <mat-icon>file_download</mat-icon>
                </button>
                <div *ngIf="loadingStatus.get(file.id)" class="spinner-container">
                  <mat-spinner diameter="24"></mat-spinner>
                </div>
              </ng-container>

              <ng-template #deletedBadge>
                <span class="deleted-badge">
                  {{'proposalDetails.versionHistoryTab.fileDeleted' | translate}}
                </span>
              </ng-template>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #noUpload>
    <div class="d-flex noUpload">
      {{'proposalDetails.noUploads' | translate}}
    </div>
  </ng-template>
</div>
